import { GenericObjectType } from '../../common/types';

export const installmentPaymentStatuses: GenericObjectType = {
  active: 'Activo',
  overdue: 'En Mora',
  paid: 'Pagado',
};
